/*
 * Copyright (c) 2021 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React, { useState } from 'react'
import Footer from './components/Footer'
import { Switch, Route } from 'react-router'
import ContentArea from './components/ContentArea'
import { makeStyles } from '@material-ui/core/styles'
import OCLCBar from './components/OCLCBar'
import { AuthenticationContext } from './contexts/AuthenticationContext'

const useCustomStyles = makeStyles(() => ({
  app: {
    textAlign: 'center',
    display: 'flex',
    height: '100vh',
    flexDirection: 'column',
    '& p': {
      fontFamily: "'Lato', 'LatoFallback', sans-serif",
    },
  },
}))

function App() {
  const classes = useCustomStyles()
  const [authData, setAuthData] = useState(false)

  return (
    <AuthenticationContext.Provider value={{ isAuth: authData, setAuthData }}>
      <div data-testid='app-wrapper' className={classes.app}>
        <Switch>
          <Route>
            <OCLCBar />
            <ContentArea />
            <Footer />
          </Route>
        </Switch>
      </div>
    </AuthenticationContext.Provider>
  )
}

export default App
